import React, { useEffect } from "react";
import styles from "../style.module.scss";
import { Image } from "@src/components/Image";
import { useSelector, useDispatch } from "react-redux";
import {
  showSelectAddressBottomSheetAction,
  showSelectStateBottomSheetAction,
} from "@src/components/BottomSheets/store/actions.js";
import { useRouter } from "@src/lib/router";
import { setSelectedStateAction } from "@src/components/Tabs/Overview/store/actions.js";
import { useTranslation } from "react-i18next";
import { getAwsAssets } from "@src/utils";
import { checkIsPincodeServicable } from "@src/components/PhysicalAddress/store/actions";
import { safeJsonParse } from "@src/utils/safeJsonParse";

const State = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const dispatch = useDispatch();

  const hasOfflineMaterial = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData
        ?.isPhysicalDeliveryEnabled
  );

  const pincodeErrorMsg = useSelector(
    (state) => state?.physicalShipmentReducer?.picodeErrorMessage
  );

  const addressList = useSelector(
    (state) => state?.physicalShipmentReducer?.addressList
  );
  const activeAddress = useSelector(
    (state) => state?.physicalShipmentReducer?.activeAddress
  );
  const isBooksAdded = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.bundleData
        ?.isBooksAdded
  );
  const enablePrefilledState = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.enablePrefilledState
  );

  const overviewData = useSelector((state) => state?.overviewReducer);
  const bundles =
    overviewData?.overViewDetails?.course?.metaData?.bundleData?.bundles;

  const handleStatesClick = () => {
    hasOfflineMaterial
      ? checkPhysicalAddress()
      : dispatch(showSelectStateBottomSheetAction(true));
  };
  const checkPhysicalAddress = () => {
    addressList?.length
      ? dispatch(showSelectAddressBottomSheetAction(true))
      : router?.push(`/${router?.query?.courseId}/physicaladdress`);
  };

  useEffect(() => {
    try {
      window.webkit?.messageHandlers?.performAction?.postMessage?.(
        JSON.stringify({
          screen: "FETCH_DEFAULT_STATE",
        })
      );
    } catch {
      // iOS handler gone
    }

    try {
      window.mobile?.performAction?.("FETCH_DEFAULT_STATE");
    } catch {
      // Android: Java object is gone / method missing
    }
  }, []);

  useEffect(() => {
    window.fetchDefaultState = (dataObj) => {
      const data = safeJsonParse(dataObj, {
        source: "StateSelection [fetchDefaultState]",
        fallback: null,
      });
      if (!data) return;
      if (!enablePrefilledState) {
        dispatch(setSelectedStateAction(data?.stateSelected));
      }
    };
  });

  useEffect(() => {
    let stateSelected = window?.localStorage?.getItem("stateSelected");
    if (stateSelected) {
      dispatch(setSelectedStateAction(stateSelected));
    }
  }, []);

  useEffect(() => {
    if (hasOfflineMaterial === 2 && activeAddress?.pinCode) {
      dispatch(checkIsPincodeServicable(activeAddress?.pinCode));
    }
  }, [activeAddress?.pinCode, activeAddress?.id]);

  return (
    <div className={styles.StateInputDiv} onClick={() => handleStatesClick()}>
      <div className={styles.StateInputDiv__Left}>
        <Image
          src={getAwsAssets("MapPin.svg", "content")}
          alt="c"
          height={20}
          width={20}
          priority={true}
          loading="eager"
        />
      </div>
      <div className={styles.StateInputDiv__Middle}>
        {!hasOfflineMaterial ? (
          overviewData?.stateSelected ? (
            <>
              {t(
                "components.tabs.overview.components.States.purchasingIn",
                "Purchasing in "
              )}{" "}
              {overviewData?.stateSelected}
            </>
          ) : (
            <>
              {t(
                "components.tabs.overview.components.States.SelectState",
                "Select State"
              )}{" "}
            </>
          )
        ) : activeAddress?.id ? (
          <div>
            <h2>{activeAddress?.lable}</h2>
            <p>
              {activeAddress?.address1},{activeAddress?.city},
              {activeAddress?.state},{activeAddress?.pinCode}
            </p>
            {pincodeErrorMsg && (
              <p className={styles.Errormsg}>{pincodeErrorMsg.split(",")[0]}</p>
            )}
            {bundles?.length > 0 && !activeAddress?.email && isBooksAdded ? (
              <p className={styles.Errormsg}>Email address is required</p>
            ) : null}
          </div>
        ) : (
          <>
            {t(
              "components.tabs.overview.components.States.SelectAddress",
              "Select Address"
            )}{" "}
          </>
        )}
      </div>
      <div className={styles.StateInputDiv__Right}>
        <Image
          src={getAwsAssets("RightNav.svg", "content")}
          alt="c"
          height={12}
          width={12}
        />
      </div>
    </div>
  );
};

export default State;
